<template>
  <div class="vw100 bg-w pt60 pb100 minh626 column a-center">
    <div class="w-per71 column a-center">

      <div class="ft36 font-Regular c-00903B">
        {{ $t('风采展示') }}
      </div>

      <div class="w-per100 column a-center mt20">

        <div class="w-per100 row flex-center ft16 font-Regular">
          <div class="w140 h50 row flex-center" :style="index==0?'':'margin-left:14px;'"
            :class="current_index==index?'c-w bg-00903B':'c-3 bg-F2F2F2'"
            v-for="(item,index) in show_list" :key="index"
            @click="changeShowTab(index)"
          >
            {{item.name}}
          </div>
        </div>

        <div class="w-per100 mt53">
          <el-carousel ref="qualshow" indicator-position="none" loop height="16.1458vw" :autoplay="false" arrow="always" :interval="5000">
              <el-carousel-item v-for="(x,y) in Math.ceil(imgs_data.length / 3)" :key="y">
                <div class="w-per100 h310 row relative px80">
                  <div
                    class="w-per30 h310" :class="index%3==0?'':'ml60'"
                    v-for="(item,index) in y == Math.ceil(imgs_data.length / 3) ? imgs_data.slice(y * 3) : imgs_data.slice(y * 3,(y + 1) * 3)"
                    :key="y * 3 + index"
                    @click.stop="toImage(item)"
                  >
                    <div class="w-per100 h-per100 column a-center" v-if="index%3==0">
                      <div class="w-per100 h270 column a-center">
                        <img loading="lazy" class="w-per100 h-per100 fit-cover" :src="getImageUrl(item.image)" alt="">
                      </div>
                      <div class="mt16 c-3 ft16 font-Regular">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="w-per100 h-per100 column a-center" v-if="index%3==1">
                      <div class="w-per100 h270 column a-center">
                        <img loading="lazy" class="w-per100 h-per100 fit-cover" :src="getImageUrl(item.image)" alt="">
                      </div>
                      <div class="mt16 c-3 ft16 font-Regular">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="w-per100 h-per100 column a-center" v-if="index%3==2">
                      <div class="w-per100 h270 column a-center">
                        <img loading="lazy" class="w-per100 h-per100 fit-cover" :src="getImageUrl(item.image)" alt="">
                      </div>
                      <div class="mt16 c-3 ft16 font-Regular">
                        {{item.name}}
                      </div>
                    </div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
        </div>

      </div>

    </div>

    <!-- 预览 -->
    <el-dialog :show-close="false" :visible.sync="show_img" center @close="close()">
      <div class="w-per100 vh60 relative" @click.stop="close()">
        <div class="wh30 absolute top0 right0 pointer">
          <el-button type="info" icon="el-icon-close" circle></el-button>
        </div>
        <div class="w-per100 h-per100">
          <el-image
            style="width: 100%; height: 100%"
            :src="getImageUrl(img_url)"
            fit="contain"
          ></el-image>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { getStaffList, getFactorysList } from "@/api/app";
export default{
  data(){
    return {
      show_list:[{id:1,name:this.$t('工厂风采')},{id:2,name:this.$t('员工风采')},],
      current_index:0,
      imgs_data:[],
      img_url:'',
      show_img:false,
    };
  },
  mounted(){
    if(this.current_index == 1){
      this._getStaffList();
    }else{
      this._getFactorysList();
    }
  },
  methods:{
    // 查看详情
    toImage(item){
      if(this.current_index == 1){
        this.$router.push({
          path: "/SPreview",
          query:{id:item.id},
        })
      }else{
        this.$router.push({
          path: "/FPreview",
          query:{id:item.id},
        })
      }
    },
    close(){
      console.log('cc');
      this.show_img  = false;
      this.img_url = '';
    },
    previewImage(img_url){
      this.show_img  = true;
      this.img_url = img_url;
    },
    // 切换
    changeShowTab(index){
      this.current_index = index;
      this.page = 1;
      if(this.current_index == 1){
        this._getStaffList();
      }else{
        this._getFactorysList();
      }
    },
    // 员工风采
    async _getStaffList(){
      let obj = {
        page:1,
        per_page:30,
      }
      const {data} = await getStaffList(obj);
      if(data.code == 1){
        this.last_page = data.data.last_page;
        if(this.page == 1){
          this.imgs_data = data.data.data;
        }else{
          let temp = this.imgs_data;
          let temp1 = data.data.data;
          if(temp1.length>0){
            this.imgs_data = [...temp,...temp1];
          }
        }
      }else{
        this.$message.error(data.msg);
      }
    },
    // 工厂风采
    async _getFactorysList(){
      let obj = {
        page:1,
        per_page:30,
      }
      const {data} = await getFactorysList(obj);
      if(data.code == 1){
        this.last_page = data.data.last_page;
        if(this.page == 1){
          this.imgs_data = data.data.data;
        }else{
          let temp = this.imgs_data;
          let temp1 = data.data.data;
          if(temp1.length>0){
            this.imgs_data = [...temp,...temp1];
          }
        }
      }else{
        this.$message.error(data.msg);
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-carousel__arrow{
  width: 2.6042vw !important;
  height: 2.8125vw !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
  color: #ffffff !important;
  font-size: 18px !important;
  border-radius: 0px !important;
}
::v-deep .el-carousel__arrow:hover{
  background-color: #00903B !important;
}
::v-deep .el-carousel__arrow--left{
  left: 0px !important;
}
::v-deep .el-carousel__arrow--right{
  right: 0px !important;
}
::v-deep .el-dialog{
  width: 50%;
  .el-dialog__header{
    padding:0;
  }
}
@media screen and (min-width: 750px) and (max-width: 1250px){
.px80{
  padding-left: 5.2083vw;
  padding-right: 5.2083vw;
}
.h310{height:21.3542vw;}
::v-deep .el-carousel__container{height:21.3542vw !important;}
::v-deep .el-carousel__arrow{
  width: 4.1667vw !important;
  height: 4.5vw !important;
  font-size: 12px !important;
}
::v-deep .el-carousel__arrow--right{
  right: 1.875vw !important;
}
::v-deep .el-dialog{
  width: 80%;
}
}
@media screen and (max-width: 750px){
.px80{
  padding-left: 5.2083vw;
  padding-right: 5.2083vw;
}
.h310{height:25vw;}
::v-deep .el-carousel__container{height:25vw !important;}
::v-deep .el-carousel__arrow{
  width: 3.125vw !important;
  height: 3.375vw !important;
  font-size: 8px !important;
}
::v-deep .el-carousel__arrow--right{
  right: 1.875vw !important;
}
::v-deep .el-dialog{
  width: 100%;
}
}
</style>